import * as types from './actionTypes';
import {beginAjaxCall, ajaxCallError} from './ajaxStatusActions';
import TimeTrackingAPI from '../api/mockTimeTrackingApi';
import moment from 'moment';

export function loadTimesheetSuccess(timeSheets) {
    return {type: types.LOAD_TIMESHEET_SUCCESS, timeSheets};
}

export function updateCourseSuccess(timeSheet) {
    return {type: types.UPDATE_TIMESHEET_SUCCESS, timeSheet};
}

export function createCourseSuccess(timeSheet) {
    return {type: types.CREATE_TIMESHEET_SUCCESS, timeSheet};
}

export function loadTimesheets() {
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return TimeTrackingAPI.getAllTimeTrackings().then(timeSheets => {
            dispatch(loadTimesheetSuccess(timeSheets));
        }).catch(error => {
            throw(error);
        });
    };
}

export function getCurrentDate() {
    return function (dispatch) {
        let currentDate = moment();
        while (currentDate.isoWeekday() > 5) {
            currentDate.subtract(1, 'days');
        }
        dispatch(setCurrentDate(currentDate.format('YYYY-MM-D')));
    }
}

function setCurrentDate(date) {
    return {type: types.SET_CURRENT_DATE, date};
}


/** WEBPACK FOOTER **
 ** ./src/actions/timesheetAction.js
 **/